import { render, staticRenderFns } from "./HotelsSearchForm.vue?vue&type=template&id=00c064f6"
import script from "./HotelsSearchForm.vue?vue&type=script&lang=js"
export * from "./HotelsSearchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputHotel: require('/home/forge/farescraper.com/components/InputHotel.vue').default,InputDate: require('/home/forge/farescraper.com/components/InputDate.vue').default,HotelsGuestRoomSelector: require('/home/forge/farescraper.com/components/HotelsGuestRoomSelector.vue').default,IconsCity: require('/home/forge/farescraper.com/components/IconsCity.vue').default})
